module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<a class="return-to-editor btn btn-primary">Return to Editor</a>\n<div class="share-button">Share</div>\n';
 if (variants.length) { ;
__p += '\n<ul class="list-inline variant-list ' +
__e( variants[0].groupType ) +
'">\n    ';
 _.each(variants, function (variant, index) { ;
__p += '\n        <li class="' +
__e( variant.id === currentId ? 'selected ' : '' ) +
'">\n            <a href="' +
__e( variant.url ) +
'" class="variant-icon ' +
__e( variant.identifier ) +
'">#' +
__e( index + 1 ) +
'</a>\n        </li>\n    ';
 }); ;
__p += '\n</ul>\n';
 } ;
__p += '\n\n<div class="preview-region">\n    <div class="zoom-region"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/viewer/PreviewNavBarView.tpl
// module id = 3039
// module chunks = 0